import { getToken } from "./token";
export const isAuthentificated = () => {
  const token = getToken();
  return token ? true : false;
};
